import { Form, MultiOption, ImageUpload, FileUpload, FlexRow } from '@/ui'
import ErrorLabel from './ErrorLabel'
import IntegrationMarkings from './IntegrationMarkings'
interface FieldDefaultProps {
  As: any
  input: any
  value?: any
  isCheckbox?: boolean
  fieldError?: boolean
  onChange?: () => void
  label?: string
  touched?: boolean
  error?: string
  title?: string
  labelText?: string
  sensitive?: boolean
  defaultRating?: number
  description?: string
  integrationMarkings?: Array<{
    dataDirection: string
    logo: string
    id: string
    name: string
    isZenegy: boolean
  }>
}

const FieldDefault = ({
  As,
  isCheckbox,
  value,
  fieldError,
  label,
  input,
  touched,
  error,
  title,
  labelText,
  sensitive,
  defaultRating,
  description,
  integrationMarkings,
  ...rest
}: FieldDefaultProps) => {
  if (As === ImageUpload || As === FileUpload) {
    delete rest.onChange
  }

  return (
    <>
      {isCheckbox && integrationMarkings && integrationMarkings.length > 0 && (
        <FlexRow noMargin justifyContent="flex-end">
          <IntegrationMarkings integrationMarkings={integrationMarkings} />
        </FlexRow>
      )}
      <Form.Field className={isCheckbox ? 'checkbox' : ''} title={title}>
        {label}

        {description && <div>{description}</div>}

        <div>
          {
            <As
              {...input}
              {...rest}
              sensitive={sensitive}
              checked={isCheckbox ? !!input.value : undefined}
              value={
                As === MultiOption && typeof value === 'string' ? [] : value
              }
              error={fieldError || undefined}
            />
          }
          {touched && error && error.length && <ErrorLabel error={error} />}
        </div>
      </Form.Field>
    </>
  )
}

export default FieldDefault
